import { i18nFileTreeParser } from 'i18n/util'

const files = require.context('.', false, /\.json$/)

export default i18nFileTreeParser(files)
